import { axiosRequest } from '../../axiosRequest';

const adapterAppRequest = (data) => {
	return data;
};

const adapterAppResponse = ({ data, success }) => {
	if (success === false) return { error: true, data };
	return data;
};

export const sendTestSms = async (testForm) => {
	const data = adapterAppRequest(testForm);
	var options = {
		method: 'post',
		url: `dashboard/notifications/send-test-sms`,
		information: data,
	};

	const response = await axiosRequest(options);

	const notification = adapterAppResponse(response);

	return notification;
};

